import { render, staticRenderFns } from "./Epaper.vue?vue&type=template&id=651ecb27&scoped=true&"
import script from "./Epaper.vue?vue&type=script&lang=js&"
export * from "./Epaper.vue?vue&type=script&lang=js&"
import style0 from "./Epaper.vue?vue&type=style&index=0&id=651ecb27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651ecb27",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDatePicker,VRow})
